// @flow

export default drawCustom;

import DepthMode from '../gl/depth_mode';
import StencilMode from '../gl/stencil_mode';

import type Painter from './painter';
import type SourceCache from '../source/source_cache';
import type CustomStyleLayer from '../style/style_layer/custom_style_layer';

function drawCustom(painter: Painter, sourceCache: SourceCache, layer: CustomStyleLayer) {
    const context = painter.context;
    const implementation = layer.implementation;
    /*
     * feat(7431):Leaflet、MapboxGL引擎支持百度、高德瓦片服务
     * 修改说明：绘制模板裁剪几何
     * 版权所有: 武汉中地数码科技有限公司
     * 修改人: 赵凯 2025-06-04
     */
    let isCloseStencilMode = true;
    if (layer._clippingFeature) {
        painter.clearStencil();
        painter.drawClippingArea(1, layer._clippingFeature);
        context.setStencilMode(
            new StencilMode(
                { func: context.gl.EQUAL, mask: 0xff },
                1,
                0xff,
                context.gl.KEEP,
                context.gl.KEEP,
                context.gl.KEEP
            )
        );
        isCloseStencilMode = false;
    }

    if (painter.renderPass === "offscreen") {
        const prerender = implementation.prerender;
        if (prerender) {
            painter.setCustomLayerDefaults();
            context.setColorMode(painter.colorModeForRenderPass());

            prerender.call(implementation, context.gl, painter.transform.customLayerMatrix());

            context.setDirty();
            painter.setBaseState();
        }

    } else if (painter.renderPass === 'translucent') {

        painter.setCustomLayerDefaults();

        context.setColorMode(painter.colorModeForRenderPass());

        if (isCloseStencilMode) {
            context.setStencilMode(StencilMode.disabled);
        }

        const depthMode = implementation.renderingMode === '3d' ?
            new DepthMode(painter.context.gl.LEQUAL, DepthMode.ReadWrite, painter.depthRangeFor3D) :
            painter.depthModeForSublayer(0, DepthMode.ReadOnly);

        context.setDepthMode(depthMode);

        implementation.render(context.gl, painter.transform.customLayerMatrix());

        context.setDirty();
        painter.setBaseState();
        context.bindFramebuffer.set(null);
    }
}
